import {Base} from "@/api/Base"

export class PolicyListAll extends Base {
    path = "policy/listAll"
}